/**
 * 主题相关
 * @type {{t这hemeData: {}}} 当前主题相关数据
 */

const state = {
  themeData:{}
}

const mutations = {
  setThemeData: (state , value) => {
    state.themeData = value;
  }
}

export default {
  state,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/theme.js